import { render, staticRenderFns } from "./StudyCourse.vue?vue&type=template&id=cea24f14&scoped=true"
import script from "./StudyCourse.vue?vue&type=script&lang=js"
export * from "./StudyCourse.vue?vue&type=script&lang=js"
import style0 from "./StudyCourse.vue?vue&type=style&index=0&id=cea24f14&prod&scoped=true&lang=css"
import style1 from "./StudyCourse.vue?vue&type=style&index=1&id=cea24f14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea24f14",
  null
  
)

export default component.exports